<div class="card card-custom">
    <div class="card-content">
        <div class="card-body" [formGroup]="optionsReferenceFormGroup">
            <div class="row" style="align-items: baseline;">
                <div class="d-flex flew-row col-lg-5 col-md-12 pr-0 mb-5">
                    <div class=" label-control mr-2">
                        Referencias
                    </div>
                    <input type="checkbox" class="form-check-input mr-5" formControlName="haveDteReference"
                        (change)="changeReference()">
                    <div class="ml-5" *ngIf="showingCurrencyOptions">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="radioCLP" name="tipoMoneda" class="custom-control-input" value="CLP"
                                formControlName="tipoMoneda" (change)="onSubmit(false)"
                                [disabled]="disableCLPOption">
                            <label class="custom-control-label" for="radioCLP">CLP</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="radioUSD" name="tipoMoneda" class="custom-control-input" value="USD"
                                formControlName="tipoMoneda" (change)="onSubmit(false)">
                            <label class="custom-control-label" for="radioUSD">USD</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="radioUF" name="tipoMoneda" class="custom-control-input" value="UF"
                                formControlName="tipoMoneda" (change)="onSubmit(false)">
                            <label class="custom-control-label" for="radioUF">UF</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="radioOther" name="tipoMoneda" class="custom-control-input"
                                value="OTHER" formControlName="tipoMoneda" (change)="onSubmit(false)">
                            <label class="custom-control-label" for="radioOther">Otros</label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 col-md-12">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="d-flex flex-row"
                            *ngIf="divisasList.length>0 && showingCurrencyOptions && !selectedForeignCurrency">

                            <p class="mr-4"><b>{{divisasList[0].nombre }}:</b> <span> $ {{divisasList[0].valorClp |
                                    number:'1.0-2':'es'}}</span></p>



                            <p class="ml-4"><b>{{divisasList[1].nombre }}</b><span> $ {{divisasList[1].valorClp |
                                    number:'1.0-2':'es'}}</span></p>

                        </div>

                        <div class="d-flex flex-row" style="align-items: center;"
                            *ngIf="optionsReferenceFormGroup.controls.tipoMoneda.value=='OTHER'">
                            <div class=" label-control mr-2">
                                Divisa
                            </div>

                            <ng-select [items]="monedasAduanaSource" [multiple]="false"
                                [placeholder]="'Seleccionar tipo de moneda'" formControlName="tipoMonedaSelector"
                                notFoundText="Moneda no encontrada" bindLabel="nombre" (blur)="onSubmit(false)"
                                (change)="changeDivisaPorSelector($event.target)"></ng-select>

                        </div>
                        <div class="d-flex flex-row" style="align-items: center;" [formGroup]="divisasValueFormGroup"
                            *ngIf="selectedForeignCurrency">
                            <div class=" label-control mr-2">
                                Valor Moneda
                            </div>
                            <div class="">
                                <input type="number" min="1" class="form-control" formControlName="newValorDivisa"
                                    style="max-width: 100px;" (change)="onSubmit(true)">

                            </div>
                        </div>
                        <div>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                    formControlName="detallesExentos" (change)="changeDetallesConIVA($event)">
                                <label class="custom-control-label label-control" for="customSwitch1">Precio detalles
                                    IVA
                                    incl.</label>
                            </div>
                        </div>
                        <div *ngIf="showGlobalRefCheckbox">
                            <div class="row">
                                <div class="col-1 ml-5 text-center pr-1">
                                    <input type="checkbox" class="form-check-input" formControlName="refGlobal"
                                        (change)="changeGlobalReference()">
                                </div>
                                <div class="col-9 label-control float-left">Referencia Global</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div *ngIf=" divisasValueFormGroup.controls.newValorDivisa.invalid" class="text-danger">
                        <div *ngIf="divisasValueFormGroup.controls.newValorDivisa.errors?.PositiveNumber">Número
                            debe ser positivo
                        </div>
                        <div *ngIf="divisasValueFormGroup.controls.newValorDivisa.errors?.min">Valor moneda mínimo de 1
                        </div>
                    </div> -->
                </div>


            </div>
            <div class="row">
                <!-- formulario referencia -->
                <div *ngIf="optionsReferenceFormGroup.controls.haveDteReference.value" class="col-12">
                    <div class="col-12">
                        <app-references-list (referencesListEmitter)="getReferencesList($event)" [invoiceType]="currentInvoiceType"></app-references-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>